import { action, makeAutoObservable } from "mobx"
import {
    MenuBookingCategory,
    MenuBookingItem,
    MenuWithExtraData,
} from "../../../../services/menu/models";

export enum BookingFormType {
    createMenu = "createMenu",
    createBookingCategory = "createBookingCategory",
    deleteBookingCategory = "deleteBookingCategory",
    createBookingItem = "createBookingItem",
    copyBookingItem = "copyBookingItem",
    editBookingItem = "editBookingItem",
    deleteBookingItem = "deleteBookingItem",
    editMenuModifiersSet = 'editMenuModifiersSet',
    deleteMenuModifiersSet = 'deleteMenuModifiersSet',
    editCategoriesForm = 'editCategoriesForm',
    editItemsOrdersForm = 'editItemsOrdersForm',
    editDeliveryConditions = 'editDeliveryConditions',
    editAlias = 'editAlias',
    updateChatForm = 'updateChatForm',
    editTimeSlots = 'editTimeSlots'
}

export enum FormDisplayType {
    popup = "popup",
    inline = "inline"
}

class BookingFormsStore {
    forms: {
        [BookingFormType.createMenu]: {
            current?: MenuWithExtraData,
            type: FormDisplayType,
            open: boolean
        },
        [BookingFormType.createBookingCategory]: {
            current?: MenuBookingCategory,
            type: FormDisplayType,
            open: boolean
        },
        [BookingFormType.deleteBookingCategory]:{
            current?: MenuBookingCategory,
            type: FormDisplayType,
            open: boolean
        },
        [BookingFormType.createBookingItem]: {
            current?: MenuBookingItem,
            type: FormDisplayType,
            open: boolean
        },
        [BookingFormType.editBookingItem]: {
            current?: MenuBookingItem,
            type: FormDisplayType,
            open: boolean
        },
        [BookingFormType.copyBookingItem]: {
            current?: MenuBookingItem,
            type: FormDisplayType.popup,
            open: boolean
        },
        [BookingFormType.deleteBookingItem]:{
            current?: MenuBookingItem,
            type: FormDisplayType,
            open: boolean
        },
        [BookingFormType.editCategoriesForm]:{
            current?: MenuBookingCategory[],
            type: FormDisplayType,
            open: boolean
        },
        [BookingFormType.editItemsOrdersForm]:{
            current?: MenuBookingCategory,
            type: FormDisplayType,
            open: boolean
        },
        [BookingFormType.editAlias]: {
            type: FormDisplayType.popup,
            open: boolean,
            current?: MenuBookingCategory,
        },
        [BookingFormType.editTimeSlots]: {
            type: FormDisplayType.popup,
            open: boolean,
            current?: MenuBookingItem,
        },
    } = {
        [BookingFormType.createMenu]: {
            type: FormDisplayType.popup,
            open: false
        },
        [BookingFormType.createBookingCategory]: {
            type: FormDisplayType.popup,
            open: false
        },
        [BookingFormType.deleteBookingCategory]: {
            type: FormDisplayType.popup,
            open: false
        },
        [BookingFormType.createBookingItem]: {
            type: FormDisplayType.popup,
            open: false
        },
        [BookingFormType.copyBookingItem]: {
            type: FormDisplayType.popup,
            open: false
        },
        [BookingFormType.editBookingItem]: {
            type: FormDisplayType.popup,
            open: false
        },
        [BookingFormType.deleteBookingItem]: {
            type: FormDisplayType.popup,
            open: false
        },

        [BookingFormType.editCategoriesForm]: {
            type: FormDisplayType.popup,
            open: false
        },
        [BookingFormType.editItemsOrdersForm]:{
            type: FormDisplayType.popup,
            open: false
        },

        [BookingFormType.editAlias]: {
            type: FormDisplayType.popup,
            open: false,
        },
        [BookingFormType.editTimeSlots]: {
            type: FormDisplayType.popup,
            open: false,
        },
    };

    constructor() {
        makeAutoObservable(this);
    }

    @action
    showPopupForm(type: BookingFormType, current?: any) {
        this.forms[type].open = true;
        this.forms[type].current = current;
        this.forms[type].type = FormDisplayType.popup;
    }

    @action
    closeForm(type: BookingFormType) {
        this.forms[type].open = false;
        this.forms[type].current = undefined;
    }



}

export default BookingFormsStore
